'use client'

import { useBlockPageSidebar } from '~/components/BlockPageLayoutClient'
import HeaderSidebarToggleButton from '~/components/HeaderSidebarToggleButton'

export default function SidebarToggleButton() {
  const { isMobileOpen, setMobileOpen } = useBlockPageSidebar()

  return (
    <HeaderSidebarToggleButton
      isOpen={isMobileOpen}
      onToggle={() => setMobileOpen(!isMobileOpen)}
    />
  )
}
